import { useT } from '@spotify-internal/i18n-core';

export const useFilterDropdownCopy = () => {
  const t = useT();

  return {
    clear: t(
      'atlas.filter_popover.clear',
      'Clear',
      'Button to clear current filter selection',
    ),
    apply: t(
      'atlas.filter_popover.apply',
      'Apply',
      'Button to apply a new filter selection',
    ),
  };
};
